import React, { Component } from 'react';

import './style.css';

class Footer extends Component {
    render() {
        return (
            <footer id="footer">
                <div className="container">
                    <div className="row">
                        <p className="col-5">
                            Application created by <a href="http://www.manuelnogueira.pt" target="_blank" rel="noopener noreferrer">Manuel Nogueira</a>
                        </p>
                        <p className="col-7 text-right">
                            For more information, or a budget on your own application, email me at <a href="emailto:geral@manuelnogueira.pt">geral@manuelnogueira.pt</a>.
                        </p>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;
